import type { ReactElement } from 'react'
import type { TFunction } from 'i18next'
import { Trash2 } from 'lucide-react'

interface DeleteSingleProps {
  onActivate: () => void
  t: TFunction<'cases'>
}

export function DeleteSingleButton({ onActivate, t }: DeleteSingleProps): ReactElement {
  return (
    <button
      onClick={onActivate}
      className="flex w-full items-center gap-2 px-3 py-2 text-sm text-red-600 hover:bg-red-50 dark:text-red-400 dark:hover:bg-red-950/50"
    >
      <Trash2 className="h-4 w-4" />
      <span>{t('infrastructure.deleteThisEndpoint')}</span>
    </button>
  )
}

export function MenuSeparator(): ReactElement {
  return <div className="my-1 border-t border-slate-200 dark:border-slate-700" />
}

interface DeleteSelectedProps {
  onActivate: () => void
  hasSelection: boolean
  selectionCount: number
  t: TFunction<'cases'>
}

export function DeleteSelectedButton({
  onActivate,
  hasSelection,
  selectionCount,
  t,
}: DeleteSelectedProps): ReactElement {
  const stateClass = hasSelection
    ? 'text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-950/50'
    : 'text-slate-400 dark:text-slate-500 cursor-not-allowed'
  const title = hasSelection
    ? t('infrastructure.deleteSelectedEndpoints', { count: selectionCount })
    : t('infrastructure.selectEndpointsFirst')
  return (
    <button
      onClick={onActivate}
      disabled={!hasSelection}
      className={`flex w-full items-center gap-2 px-3 py-2 text-sm ${stateClass}`}
      title={title}
    >
      <Trash2 className="h-4 w-4" />
      <span>{t('infrastructure.deleteAllSelected')}</span>
      {hasSelection && <span className="ml-auto text-xs font-medium">({selectionCount})</span>}
    </button>
  )
}
